import React, { useEffect, useState } from "react";
import { AvForm } from "availity-reactstrap-validation";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Card, CardBody, Col, Container, Button, Row, Label, Form } from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import moment from "moment";
import { frxAppOptions, happeningTypeOptions, mallOptions } from "../../common/constants";
import { CircularProgress } from "@material-ui/core";
import _, { isObject } from "lodash";
import ReactQuill from "react-quill";

const EditGrabPromo = (props) => {
  const statusOptions = [
    { value: "Y", label: "Enable" },
    { value: "N", label: "Disable" },
  ];

  const [propsData, setPropsData] = useState(props?.location?.state);
  const [promotionalText, setPromotionalText] = useState();
  const [promotionalDescription, setPromotionalDescription] = useState();
  const [publishDate, setPublishDate] = useState("");
  const [unPublishDate, setUnPublishDate] = useState("");
  const [neverEnding, setNeverEnding] = useState(false);
  const [status, setStatus] = useState(statusOptions[0].value);
  const [version, setVersion] = useState();
  const [successAlert, setSuccesAlert] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [token, setToken] = useState();
  const [loader, setLoader] = useState(false);

  // Global nav state
  const [navigation, setNavigation] = useState();
  const [selectedFRXSection, setselectedFRXSection] = useState(
    frxAppOptions[frxAppOptions.length - 1]
  );
  
  const [externalUrl, setExternalUrl] = useState();
  const [externalUrlErrorMessage,setExternalUrlErrorMessage]=useState('')
  const [externaLinkName,setExternalLinkName]=useState("")
  const [customCheck, setcustomCheck] = useState(false);
  const [customNavigation, setCustomNavigation] = useState(
    JSON.stringify({ section: "", custom: true })
  );
  
  // Add state for ArticleDetail integration
  const [selectedMall, setSelectedMall] = useState(null);
  const [selectedHappeningType, setSelectedHappeningType] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken");
    setToken(token);
    if (props.location.state?.edit) {
      setPropsData(props?.location?.state);
      var promotional_title = props.location.state?.item?.promotional_title;
      var promotional_description =
        props.location.state?.item?.promotional_description;
      var navigation_1 = props.location.state?.item?.navigate_to;
      var status = props.location.state?.item?.item_status;
      var version = props.location.state?.item?.item_version;
      var publish_date = props.location.state?.item?.publish_date;
      var unpublish_date = props.location.state?.item?.unpublish_date;
      if (unpublish_date == "null" || !unpublish_date) {
        setNeverEnding(true);
        setUnPublishDate("");
      } else {
        setUnPublishDate(moment(unpublish_date).format("YYYY-MM-DDTHH:mm"));
      }
      // external Url set for each section
      const data = props?.location?.state?.item;
      let sec1 = data ? JSON.parse(data?.navigate_to) : "";
      if (sec1?.url) {
        setExternalUrl(sec1?.url);
        setExternalLinkName(sec1?.external_link_name)
      }
      setPromotionalText(promotional_title);
      setPromotionalDescription(promotional_description);
      setNavigation(navigation_1);
      setVersion(version)
      setStatus(status);
      setPublishDate(moment(publish_date).format("YYYY-MM-DDTHH:mm"));

      handleEditChanges(data);

      // Parse navigate_to for ArticleDetail
      const navigateTo = props?.location?.state?.item?.navigate_to;
      if (navigateTo) {
        try {
          const parsedNavigateTo = JSON.parse(navigateTo);
          handleEditChanges(parsedNavigateTo);
          if (parsedNavigateTo?.section === "ArticleDetail") {
            setNavigation(parsedNavigateTo); // <-- Fix: set navigation to parsed object
            const [mallValue, happeningTypeValue, articleId] = parsedNavigateTo?.params?.data?.split('|') || [];
            const defaultMall = mallOptions?.find(option => option.label=== mallValue);
            if (defaultMall) {
              setSelectedMall(defaultMall);
            }
            const defaultHappeningType = happeningTypeOptions?.find(option => option.value === happeningTypeValue);
            if (defaultHappeningType) {
              setSelectedHappeningType(defaultHappeningType);
            }
          }
        } catch (e) {
          console.error("Error parsing navigate_to", e);
        }
      }
    }
  }, []);

  const handleEditChanges =(data)=>{
    let navigation1 = {};
    if (data?.navigate_to?.includes("{")) {
      navigation1 = JSON.parse(data?.navigate_to);
      setNavigation(navigation1);
    }
    if (navigation1?.custom) {
      setcustomCheck(true);
      setCustomNavigation(props?.location?.state?.item?.navigate_to);
    } else {
      setCustomNavigation(JSON.stringify({ section: "", custom: true }));
      if (data?.navigate_to?.includes("{")) {
        setNavigation(navigation1);
      }

      if (data?.navigate_to?.includes("{")) {
        if (navigation1?.params?.show_add_selection_modal) {
          setselectedFRXSection({
            label: "Add Gift Card",
            value: "add_gift_card",
          });
        } else if (navigation1?.params?.show_buy_selection_modal) {
          setselectedFRXSection({
            label: "Buy Gift Card",
            value: "buy_gift_card",
          });
        } else {
          frxAppOptions?.map((item) => {
            if (item?.value == navigation1?.section) {
              setselectedFRXSection(item);
              return;
            }
          });
        }
      } else {
        frxAppOptions?.map((item) => {
          if (item.value == data?.navigate_to) {
            setselectedFRXSection(item);
          } else {
            if (data?.navigate_to?.includes("")) {
              setselectedFRXSection({ label: "No Navigation", value: "" });
              return;
            }
          }
        });
      }
    }
  }
  

  const handleSubmit = () => {
    const link = document.getElementById("campaign_link_input")?.value
    ? document.getElementById("campaign_link_input")?.value
    : "";
    const article_id = document.getElementById("article_id")?.value;
    const titleFRX = document.getElementById("title_input_frx")?.value;

    if (!promotionalText) {
      setErrorMessage("Please Enter Promotional Title");
      setErrorAlert(true);
      return;
    } else if (!promotionalDescription) {
      setErrorMessage("Please Enter Promotional Description");
      setErrorAlert(true);
      return;
    }else if (customCheck) {
      if (!customNavigation) {
        setErrorMessage("Please Enter Navigation");
        setErrorAlert(true);
        return;
      }
    } 
    
    if(selectedFRXSection.value == "NA"){
      if(!externalUrl){
        setErrorMessage("Please Enter URL")
        setErrorAlert(true)
        return
      }else if(externalUrlErrorMessage){
        setErrorMessage("Please enter valid URL")
        setErrorAlert(true)
        return
      }else if(!checkTextInsideHtml(externaLinkName)){
        setErrorMessage("Please Enter Exit Message Description")
        setErrorAlert(true)
        return
      }
    }

    if (publishDate == "Invalid date" || !publishDate) {
      setErrorMessage("Please select publish date");
      setErrorAlert(true);
      return;
    } else if (!neverEnding) {
      if (unPublishDate == "Invalid date" || !unPublishDate) {
        setErrorMessage("Please select unpublish date");
        setErrorAlert(true);
        return;
      } else if (unPublishDate < publishDate) {
        setErrorMessage("Unpublish date should be after the publish date");
        setErrorAlert(true);
        return;
      }
    }

    if(!version){
      setErrorMessage("Please enter item version")
      setErrorAlert(true)
      return
    }

    let _deeplinkObj = {
      section: "",
      params: {
        
      },
      website_params: {},
    };
    _deeplinkObj.section = "GrabPromo";
    _deeplinkObj.params.CampaignMedium = "GrabPromo";
    _deeplinkObj.params.link = "Grab Promo";

    //Navigation_1_Object_creation
    let _deeplinkObjFRX1 = {
      section: "",
      params: {
        
      },
    };
    if (selectedFRXSection) {
      _deeplinkObjFRX1.section = selectedFRXSection.value;
      _deeplinkObjFRX1.params.CampaignMedium = "GrabPromo";
      _deeplinkObjFRX1.params.Link = link;

      if (selectedFRXSection.value == "ewallet") {
        _deeplinkObjFRX1.params = selectedFRXSection.params;
      } else if (selectedFRXSection.value == "NA") {
        _deeplinkObjFRX1 = {};
        _deeplinkObjFRX1.section = "NA";
        _deeplinkObjFRX1.url = externalUrl;
        _deeplinkObjFRX1.external_link_name=externaLinkName;
      } else if (selectedFRXSection.value == "UobUni") {
        _deeplinkObjFRX1.section = "UobUni";
      } else if (selectedFRXSection.value == "ShowQR") {      
        _deeplinkObjFRX1.section = "ShowQR";
      }else if(selectedFRXSection?.value == "FRxMemberSpending"){
        _deeplinkObjFRX1.login_required = true
      } else if (selectedFRXSection.value == "digital_gift_card") {
        _deeplinkObjFRX1.section = "digital_gift_card";
        _deeplinkObjFRX1.params._params = "digital_gift_card_listing";
      } else if (selectedFRXSection.value == "add_gift_card") {
        _deeplinkObjFRX1.section = "digital_gift_card";
        _deeplinkObjFRX1.params.show_add_selection_modal = true;
      } else if (selectedFRXSection.value == "buy_gift_card") {
        _deeplinkObjFRX1.section = "digital_gift_card";
        _deeplinkObjFRX1.params.show_buy_selection_modal = true;
      } else if (selectedFRXSection.value == "ArticleDetail") {
        // Updated ArticleDetail format
        _deeplinkObjFRX1.params.data = `${selectedMall?.label}|${selectedHappeningType?.value}|${article_id}`;
        _deeplinkObjFRX1.params.title = titleFRX;
        _deeplinkObjFRX1.params.article = {
          category: titleFRX,
          id: `${selectedMall?.label}|${selectedHappeningType?.value}|${article_id}`,
        };
      } else if (selectedFRXSection.value == "RewardsTab") {
        _deeplinkObjFRX1.params.Link = link;
      } else if (selectedFRXSection.value == "No Navigation") {
        _deeplinkObjFRX1 = " ";
      } else if (selectedFRXSection.value == "BuyForMySelf") {
        _deeplinkObjFRX1.params.buy_for = "me";
      }
    }
    setLoader(true);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);
    myHeaders.append(
      "Cookie",
      "__cfduid=d5b74235daa6f013fde0aba762ec288811620640208"
    );

    var formdata = new FormData();
    formdata.append("id", propsData?.item?.id);
    formdata.append("_method", "PUT");
    formdata.append("promotional_title", promotionalText);
    formdata.append("promotional_description", promotionalDescription);
    formdata.append("item_status", status);
    formdata.append("item_type", "MarketPlaceBanner");
    formdata.append("page", "grab_promo");
    formdata.append("item_version", version);
    formdata.append("sort_order", 1);
    formdata.append("publish_date", publishDate);
    formdata.append("unpublish_date", neverEnding ? null : unPublishDate);
    formdata.append(
      "navigate_to",
      customCheck ? customNavigation : JSON.stringify(_deeplinkObjFRX1)
    );

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_TOKRI_API_URL}/api/marketplacebanners/update`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        setLoader(false)
        if (result) {
          if (result?.message.includes("update")) {
            setSuccesAlert(true);
          }
        } else {
          setErrorMessage("Unable to update Grab Promo");
          setErrorAlert(true);
        }
      })
      .catch((error) => {
        console.log("error", error);
        setLoader(false);
      });
  };
  const checkCharacterCount = (e, count) => {
    if (e.target.innerText.length > count && e.key !== 'Backspace') {
      e.preventDefault()
    }
  }
  const checkTextInsideHtml = (htmlString) => {
    const regex = /<[^>]+>([^<]+)<\/[^>]+>/;
    const matchBookingInfo = regex.exec(htmlString);
    if (matchBookingInfo && matchBookingInfo[1]) {
      return true;
    } else {
      const simpleStringRegex = /^[^<>\n]+$/;
      return simpleStringRegex.test(htmlString);
    }
  };
  const handleExternalUrl = (value) =>{
    setExternalUrl(value)
    var pattern = /^(https:\/\/|http:\/\/)([a-z]{2,})\.([a-zA-Z0-9-]{2,})+\.[a-z]{2,}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/;
    if(value){
      if (!pattern.test(value)) {
        setExternalUrlErrorMessage("Please enter valid URL (Including https://)");
      } else {
        setExternalUrlErrorMessage("");
      }
    }else{
      setExternalUrlErrorMessage("");
    }
  }
  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success"
        beforeUnmount={() => {
          props?.history.push("/market-place/grab-promo");
        }}
        onConfirm={() => {
          props?.history.push("/market-place/grab-promo");
          setSuccesAlert(false);
          setLoader(false);
        }}
        onCancel={() => {
          setSuccesAlert(false);
        }}
      >
        {"Grab Promo updated successfully"}
      </SweetAlert>
    );
  };

  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorAlert(false);
          setLoader(false);
        }}
      >
        {errorMessage ? errorMessage : "Error. Something went wrong."}
      </SweetAlert>
    );
  };

  const GlobalNavDropDown = () => {
    return (
      <Form>
        <Row>
          <Col lg={4} md={10} sm={10}>
            <div className="mb-3">
              <Label>Navigate To</Label>
              {customCheck ? (
                <textarea
                  rows={4}
                  col={20}
                  type="text"
                  className="form-control"
                  id="item_group_input"
                  onChange={(e) => {
                    setCustomNavigation(e.target.value);
                  }}
                  defaultValue={customNavigation}
                />
              ) : (
                <Select
                  isSearchable={true}
                  value={selectedFRXSection}
                  onChange={(e) => {
                    setselectedFRXSection(e);
                  }}
                  placeholder={
                    selectedFRXSection?.label
                      ? selectedFRXSection?.label
                      : "Choose section..."
                  }
                  defaultValue={frxAppOptions[0]}
                  options={frxAppOptions}
                  maxMenuHeight={120}
                  menuPlacement="auto"
                  required
                />
              )}
            </div>
          </Col>
          <Col md={1}></Col>
          <Col md={2} style={{ paddingTop: "38px" }}>
            <div className="form-check form-switch">
              <input
                type="checkbox"
                className="form-check-input checkbox"
                id="checkbox_custom_nav"
                value={customCheck}
                defaultChecked={customCheck}
                onClick={() => {
                  setcustomCheck(!customCheck);
                }}
              />

              <label className="form-check-label" htmlFor="checkbox_pocuno">
                Custom Navigation
              </label>
            </div>
          </Col>
        </Row>
        <Row>
          {(selectedFRXSection?.label == "External Link" && !customCheck) && (
            <Col lg={4} md={6} sm={6}>
              <div className="mb-3">
                <Label>URL*</Label>
                <input
                  className="form-control"
                  type="text"
                  defaultValue={externalUrl}
                  id="campaign_link_input"
                  onChange={(e) => {
                    handleExternalUrl(e.target.value)
                  }}
                />
              {externalUrlErrorMessage && (
                <p style={{ color: "red", fontSize: 12 }}>
                  {externalUrlErrorMessage}
                </p>
              )}
              </div>
            </Col>
          )}
        </Row>
        <Row>
          { (selectedFRXSection?.label == "External Link" && !customCheck) &&
            <Col lg={4} md={6} sm={6}>
            <div className="mb-3">
              <Label>{"Exit Message Description*"}</Label>
              <ReactQuill
                modules={{
                  toolbar: [
                    ["bold", "italic", "underline"],
                    [{ list: "ordered" }, { list: "bullet" }],
                    ["link", { color: [] }],
                    ["clean"],
                  ],
                }}
                theme="snow"
                value={externaLinkName}
                onChange={(e, delta, source, c) => {
                  if (c.getText().length <= 2000) {
                    setExternalLinkName(e);
                  } else if (c.getText().length > 2000) {
                    const remainingCharacters = 2000 - c.getText().length;
                    let truncatedText = c.getText().slice(0, remainingCharacters);
                    setExternalLinkName(truncatedText)
                  }
                }}
                onKeyDown={(e) => checkCharacterCount(e, 2000)}
                style={{ minHeight: "30px" }}
              />
            </div>
                      </Col>
            }
          </Row>
        {/* New ArticleDetail Integration */}
        {(selectedFRXSection?.value == "ArticleDetail" && !customCheck) && (
          <>
            <Row>
              <Col lg={4} md={6} sm={6}>
                <div className="mb-3">
                  <Label>Mall</Label>
                  <Select
                    isSearchable={true}
                    onChange={(e) => {
                      setSelectedMall(e);
                      setSelectedHappeningType(null);
                    }}
                    options={mallOptions}
                    placeholder="Select Mall..."
                    value={selectedMall}
                  />
                </div>
              </Col>
            </Row>
            
            {selectedMall && (
              <Row>
                <Col lg={4} md={6} sm={6}>
                  <div className="mb-3">
                    <Label>Type</Label>
                    <Select
                      isSearchable={true}
                      onChange={(e) => {
                        setSelectedHappeningType(e);
                      }}
                      options={happeningTypeOptions}
                      placeholder="Select Happening Type..."
                      value={selectedHappeningType}
                    />
                  </div>
                </Col>
              </Row>
            )}
            
            {selectedHappeningType && (
              <>
                <Row>
                  <Col lg={4} md={6} sm={6}>
                  <div className="mb-3">
                   <Label>Blog ID</Label>
                    <input
                      className="form-control"
                      type="text"
                      defaultValue={
                       navigation?.params?.data?.split('|')[2] || '' // Extract article ID from params
                    }
                      id="article_id"
                    />
                  </div>
                  </Col>
                </Row>
                <Row >
                  <Col lg={4} md={6} sm={6}>
                  <div className="mb-3">
                  <Label>Header Title</Label>
                    <input
                      className="form-control"
                      type="text"
                      defaultValue={
                      navigation?.params?.title
                    }
                      id="title_input_frx"
                    />
                  </div>
                  </Col>
                </Row>
              </>
            )}
          </>
        )}
      </Form>
    );
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs breadcrumbItem="Edit Grab Promo" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm className="needs-validation">
                    <Card
                      style={{
                        border: "2px solid #EEEEEE",
                        borderTop: "3px solid rgba(71, 82, 93, 0.34)",
                        borderRadius: "20px",
                      }}
                    >
                      <CardBody>
                        <Row>
                          <Col md={3} className="mb-4">
                            <h2
                              style={{ color: "#47525d57", fontWeight: "700" }}
                            >
                              Promotional Message
                            </h2>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={4} md={10} sm={10}>
                            <div className="mb-3">
                              <Label>Title</Label>
                              <input
                                type="text"
                                className="form-control"
                                id="item_name_input"
                                onChange={(e) => {
                                  setPromotionalText(e.target.value);
                                }}
                                defaultValue={promotionalText}
                              />
                            </div>
                          </Col>
                          <Col md={1}></Col>
                        </Row>
                        <Row>
                          <Col md={4}>
                            <div className="mb-3">
                              <Label>Description</Label>
                              <input
                                type="text"
                                className="form-control"
                                id="item_group_input"
                                onChange={(e) => {
                                  setPromotionalDescription(e.target.value);
                                }}
                                defaultValue={promotionalDescription}
                              />
                            </div>
                          </Col>
                        </Row>
                        {GlobalNavDropDown()}
                      </CardBody>
                    </Card>
                    <Card>
                      <CardBody>
                        <Row>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Publish At</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  type="datetime-local"
                                  onChange={(e) => {
                                    setPublishDate(
                                      moment(e.target.value).format(
                                        "YYYY-MM-DDTHH:mm"
                                      )
                                    );
                                  }}
                                  defaultValue={publishDate}
                                />
                              </div>
                            </div>
                          </Col>
                          <Col lg={1}></Col>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Unpublish At</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  type="datetime-local"
                                  onChange={(e) => {
                                    setUnPublishDate(
                                      moment(e.target.value).format(
                                        "YYYY-MM-DDTHH:mm"
                                      )
                                    );
                                  }}
                                  defaultValue={unPublishDate}
                                  disabled={neverEnding}
                                />
                              </div>
                            </div>
                          </Col>
                          <Col style={{ paddingTop: 35 }}>
                            <div className="form-check form-switch">
                              <input
                                type="checkbox"
                                className="form-check-input checkbox"
                                id="checkbox_1"
                                checked={neverEnding}
                                onChange={() => {
                                  setNeverEnding(!neverEnding);
                                }}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="checkbox_1"
                              >
                                Never-ending
                              </label>
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                    <Card>
                      <CardBody>
                        <Row>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Status</Label>
                              <Select
                                isSearchable={true}
                                onChange={(e) => {
                                  setStatus(e.value);
                                }}
                                options={statusOptions}
                                placeholder={
                                  status
                                    ? status == "Y"
                                      ? "Enable"
                                      : "Disable"
                                    : "Choose..."
                                }
                                defaultValue={status}
                                required
                              />
                            </div>
                          </Col>
                          <Col lg={1}></Col>
                          <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Item Version</Label>
                              <div className="col-md-12">
                                <input
                                min={0}
                                  className="form-control"
                                  onChange={(e) => {
                                    setVersion(e.target.value);
                                  }}
                                  type="number"
                                  id="version_input"
                                  defaultValue={version}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                    <div style={{ textAlign: "right" }} className="btn-sec">
                      <Button
                        onClick={() => {
                          props.history.push("/market-place/grab-promo");
                        }}
                        color="danger"
                        type="submit"
                      >
                        Cancel
                      </Button>
                      <button
                        disabled={loader}
                        style={{
                          color: "#ffffff",
                          width: "80px",
                          marginLeft: "10px",
                        }}
                        className={"btn btn-success"}
                        onClick={() => {
                          handleSubmit();
                        }}
                        color="success"
                        type="submit"
                      >
                        {loader ? (
                          <CircularProgress
                            size={15}
                            value={100}
                            color={"white"}
                          />
                        ) : (
                          "Save"
                        )}
                      </button>
                    </div>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {successAlert ? renderSuccessAlert() : null}
          {errorAlert ? renderFailureAlert() : null}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default EditGrabPromo;